import { useQuery } from '@tanstack/react-query';
import queryFnFactory from './authorized-users-get-query';
import { authorizedUsersGetCacheKey } from './authorized-users-get-cache-key';
export function useAuthorizedUsersGetQuery({ config, keyProps, queryOptions = {} }) {
    return useQuery({
        queryKey: authorizedUsersGetCacheKey(keyProps),
        queryFn: queryFnFactory(config, keyProps),
        refetchOnMount: 'always',
        ...queryOptions
    });
}
